import axios from 'axios';

const autoApplyApi = {
	getJobFunctions: async () => {
		const result = await axios.get('/api/job-functions');
		return result.data;
	},
};

export default autoApplyApi;
